<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        append-to-body
        center
        top="3%"
        width="60%">
        <div class="flex flex-direction padding-lr-xs" style="height: 70vh;overflow: auto">
            <div class="text-xxl line-height text-bold text-black text-center">{{detail.title}}</div>
            <div class="flex align-center justify-around margin-top-sm">
                <div class="text-df text-gray"><i class="el-icon-time text-red"></i>时间：{{detail.meeting_time}}</div>
                <div class="text-df text-gray"><i class="el-icon-location text-red"></i>地点：{{detail.address}}</div>
            </div>
            <div class="label-classify-title">会议通知</div>
            <div class="margin-top-sm detail" v-html="detail.content"></div>
            <div class="margin-top-sm" v-if="detail.status >= 2">
                <div class="label-classify-title flex align-center">
                    <div>应到人数</div>
                    <div class="margin-left">{{ detail.ought_num }}</div>
                </div>
                <div class="label-classify-title flex align-center margin-top-sm">
                    <div>实到人数</div>
                    <div class="margin-left">{{ detail.solid_num }}</div>
                </div>
                <div class="flex margin-top-sm">
                    <div class="label-classify-title flex align-center flex-sub">
                        <div>缺席人数</div>
                        <div class="margin-left">{{ detail.absent_num }}</div>
                    </div>
                    <div class="label-classify-title flex align-center flex-treble margin-left">
                        <div>缺席原因</div>
                        <div class="margin-left text-df">{{ detail.absent_remark }}</div>
                    </div>
                </div>
                <div class="label-classify-title flex align-center margin-top-sm">
                    <div>发言要点</div>
                </div>
                <div class="text-df line-height text-indent margin-tb-sm">{{ detail.speak_remark }}</div>
                <div class="label-classify-title flex align-center margin-top-sm">
                    <div>不同意见</div>
                </div>
                <div class="text-df line-height text-indent margin-tb-sm">{{ detail.opinion || '--' }}</div>
                <div class="label-classify-title flex align-center margin-top-sm">
                    <div>表决表</div>
                </div>
                <upload-file type="file" :files="detail.vote_table" multiple disabled></upload-file>
                <div class="label-classify-title flex align-center margin-top-sm">
                    <div>大会决议</div>
                </div>
                <div class="text-df line-height text-indent margin-top-sm">{{ detail.meeting_remark || '--' }}</div>
            </div>
            <div class="margin-top-sm" v-if="detail.status >= 3">
                <div class="label-classify-title">会议简报</div>
                <div class="text-df text-black text-center text-bold margin-top-sm">{{detail.meeting_title}}</div>
                <div class="margin-top-sm detail" v-html="detail.meeting_content"></div>
            </div>
            <div class="label-classify-title flex align-center margin-top-sm">
                <div>会议材料</div>
            </div>
            <upload-file class="margin-tb-sm" type="file" :files="detail.meeting_file" multiple disabled></upload-file>
        </div>
    </el-dialog>
</template>

<script>


import {getMeetingDetail} from "@/api";
import UploadFile from "@/views/web/components/UploadFile";

export default {
    name: "MemberMeetingDetailDialog",
    components: {UploadFile},
    data() {
        return {
            detail:''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: {//1党员大会 2 委员会
            type: Number,
            default: 1
        },
        aid: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.aid) this.init()
    },
    methods: {
        async init() {
            let _data = await getMeetingDetail(this.aid)
            _data.data.vote_table = _data.data.vote_table ? JSON.parse(_data.data.vote_table) : []
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        aid() {
            if (this.aid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.label-classify-title {
    font-size: 24px;
    color: #333333;
    position: relative;
    border-bottom: 3px solid #a0121222;
    height: 50px;
    line-height: 50px;
    &::before{
        position: absolute;
        width: 98px;
        height: 4px;
        background-color: #a01212;
        content: '';
        bottom: -3px;
        left: 0;
    }
}
</style>